// Mock data for Flycher Travels — replaced by backend API later.
// Images are placeholders (real AI group photos generated in backend phase).

export const GROUP_PHOTOS = [
  "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1507237615867-0d4d2ad6b2d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.pexels.com/photos/36729310/pexels-photo-36729310.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/36729290/pexels-photo-36729290.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1508904635850-d986b19765d0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1464207687429-7505649dae38?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1768899348646-c36a7ababe34?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1786047072937-bc1e04afa2a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1778239009414-f7c456eec73d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.pexels.com/photos/30650727/pexels-photo-30650727.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const SCENIC = {
  bali1: "https://images.unsplash.com/photo-1604999333679-b86d54738315?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bali2: "https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  singapore1: "https://images.unsplash.com/photo-1496939376851-89342e90adcd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  singapore2: "https://images.unsplash.com/photo-1508964942454-1a56651d54ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  halong: "https://images.unsplash.com/photo-1643029891412-92f9a81a8c16?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  sigiriya: "https://images.unsplash.com/photo-1612862862126-865765df2ded?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bangkok: "https://images.unsplash.com/photo-1562602833-0f4ab2fc46e3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kl: "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

const baseItinerary = (places) =>
  places.map((p, i) => ({
    day: i + 1,
    title: p.title,
    detail: p.detail,
  }));

export const TOURS = [
  {
    id: "t1",
    slug: "singapore-genting-dream-cruise",
    title: "Singapore With Genting Dream Cruise Premium Tour",
    withFlights: true,
    location: "Singapore",
    country: "Singapore",
    duration: "5 Nights | 6 Days",
    nights: 5,
    price: 111000,
    status: "AVAILABLE",
    fill: 62,
    cover: SCENIC.singapore1,
    tagline: "Singapore With Genting Dream Cruise",
    short:
      "The perfect blend of Singapore's iconic attractions and a luxurious Star Dream Cruise.",
    description:
      "Experience the perfect blend of Singapore's iconic attractions and a luxurious Star Dream Cruise. Explore breathtaking gardens, vibrant city landmarks, world-famous Sentosa Island, and enjoy two unforgettable nights sailing the seas with premium entertainment, delicious dining, and spectacular ocean views.",
    highlights: [
      "Gardens by the Bay & Marina Bay Sands",
      "Sentosa Island & Universal Studios",
      "2 nights on Genting Dream Cruise",
      "City tour with Merlion Park",
    ],
    inclusions: ["Return flights", "4★ hotel + cruise cabin", "Daily breakfast", "Airport transfers", "Sightseeing", "Travel insurance"],
    exclusions: ["Visa fees", "Personal expenses", "2% TCS (as applicable)", "Anything not mentioned in inclusions"],
    gallery: [GROUP_PHOTOS[0], SCENIC.singapore2, GROUP_PHOTOS[1], SCENIC.singapore1],
    itinerary: baseItinerary([
      { title: "Arrive Singapore", detail: "Airport pickup, hotel check-in, evening at leisure by Marina Bay." },
      { title: "City & Gardens", detail: "Gardens by the Bay, Merlion Park and the Marina Bay light show." },
      { title: "Sentosa Island", detail: "Cable car, Universal Studios and beachfront leisure." },
      { title: "Board the Cruise", detail: "Embark the Genting Dream Cruise, sail with premium dining." },
      { title: "Cruise Day", detail: "Onboard entertainment, spa, pools and ocean views." },
      { title: "Departure", detail: "Disembark, transfer to airport for return flight." },
    ]),
  },
  {
    id: "t2",
    slug: "sri-lanka-premium",
    title: "Sri Lanka Premium Tour",
    withFlights: true,
    location: "Sri Lanka",
    country: "Sri Lanka",
    duration: "4 Nights | 5 Days",
    nights: 4,
    price: 66500,
    status: "AVAILABLE",
    fill: 48,
    cover: SCENIC.sigiriya,
    tagline: "Culture, Heritage & Paradise",
    short: "Kandy • Bentota • Colombo — ancient heritage, lush mountains and golden beaches.",
    description:
      "Experience the best of Sri Lanka, where ancient heritage, lush mountains, golden beaches, exotic wildlife, and vibrant cities come together in one unforgettable journey. From sacred temples and elephant encounters to scenic river safaris and tropical coastlines, every day promises a new adventure.",
    highlights: ["Sigiriya Rock Fortress", "Temple of the Tooth, Kandy", "Bentota beaches & river safari", "Colombo city tour"],
    inclusions: ["Return flights", "4★ hotels", "Daily breakfast & dinner", "Private transfers", "Sightseeing", "Travel insurance"],
    exclusions: ["Visa fees", "Personal expenses", "2% TCS (as applicable)", "Lunch"],
    gallery: [GROUP_PHOTOS[2], SCENIC.sigiriya, GROUP_PHOTOS[3], GROUP_PHOTOS[4]],
    itinerary: baseItinerary([
      { title: "Arrive Colombo → Kandy", detail: "Pickup and drive to Kandy, evening cultural show." },
      { title: "Kandy", detail: "Temple of the Tooth, botanical gardens and lake walk." },
      { title: "Kandy → Bentota", detail: "Scenic drive, Madu river safari and beach evening." },
      { title: "Bentota → Colombo", detail: "Beach leisure and Colombo city tour with shopping." },
      { title: "Departure", detail: "Transfer to airport for return flight." },
    ]),
  },
  {
    id: "t3",
    slug: "3-country-malaysia-vietnam-thailand",
    title: "3 Country Tour Premium Package (Malaysia • Vietnam • Thailand)",
    withFlights: true,
    location: "Malaysia, Vietnam, Thailand",
    country: "Multi Country Tour",
    duration: "9 Days | 8 Nights",
    nights: 8,
    price: 125000,
    status: "AVAILABLE",
    fill: 55,
    cover: SCENIC.kl,
    tagline: "One Journey • Three Countries • Endless Memories",
    short: "Kuala Lumpur, Ba Na Hills & Hoi An, Pattaya & Coral Island — three countries, one trip.",
    description:
      "Discover the perfect blend of modern cities, breathtaking landscapes, rich culture, and tropical beaches on this unforgettable 9-Day Southeast Asia Group Tour. Explore the vibrant streets of Kuala Lumpur, experience the magical Ba Na Hills & Hoi An in Vietnam, and unwind on the stunning beaches of Pattaya & Coral Island in Thailand.",
    highlights: ["Petronas Towers, Kuala Lumpur", "Golden Bridge, Ba Na Hills", "Ancient town of Hoi An", "Coral Island, Pattaya"],
    inclusions: ["Return + inter-country flights", "4★ hotels", "Daily breakfast", "All transfers", "Guided sightseeing", "Travel insurance"],
    exclusions: ["Visa fees", "Personal expenses", "2% TCS (as applicable)", "Optional activities"],
    gallery: [GROUP_PHOTOS[5], SCENIC.kl, GROUP_PHOTOS[6], GROUP_PHOTOS[7]],
    itinerary: baseItinerary([
      { title: "Arrive Kuala Lumpur", detail: "City tour, Petronas Towers photo stop." },
      { title: "Kuala Lumpur", detail: "Batu Caves, Genting Highlands cable car." },
      { title: "Fly to Da Nang", detail: "Evening at the Dragon Bridge." },
      { title: "Ba Na Hills", detail: "Golden Bridge, cable car and French Village." },
      { title: "Hoi An", detail: "Ancient town, lantern-lit river cruise." },
      { title: "Fly to Bangkok → Pattaya", detail: "Transfer and evening leisure." },
      { title: "Coral Island", detail: "Speedboat tour and water sports." },
      { title: "Bangkok", detail: "City tour and shopping." },
      { title: "Departure", detail: "Transfer to airport for return flight." },
    ]),
  },
  {
    id: "t4",
    slug: "bali-premium-5n6d",
    title: "Bali Premium Package 5 Nights & 6 Days",
    withFlights: true,
    location: "Indonesia",
    country: "Bali (Indonesia)",
    duration: "5 Nights | 6 Days",
    nights: 5,
    price: 77500,
    status: "AVAILABLE",
    fill: 40,
    cover: SCENIC.bali1,
    tagline: "Bali Premium Escape",
    short: "Where every sunrise begins a new adventure — beaches, rice terraces & volcanoes.",
    description:
      "Leave the ordinary behind and step into the breathtaking beauty of Bali – the Island of Gods. From sun-kissed beaches and emerald rice terraces to majestic volcanoes and vibrant cultural landmarks, this journey is thoughtfully designed to give you the perfect balance of adventure, relaxation, and unforgettable experiences.",
    highlights: ["Ulun Danu & Tanah Lot temples", "Kintamani volcano views", "Ubud rice terraces & swing", "Finns Beach Club"],
    inclusions: ["Return flights", "Premium hotel + breakfast", "Private transfers", "ATV & Bali swing", "Guided sightseeing", "Travel insurance"],
    exclusions: ["Visa on arrival", "Personal expenses", "2% TCS (as applicable)", "Lunch & dinner"],
    gallery: [GROUP_PHOTOS[8], SCENIC.bali1, SCENIC.bali2, GROUP_PHOTOS[9]],
    itinerary: baseItinerary([
      { title: "Arrive Bali", detail: "Airport pickup and beachside check-in." },
      { title: "South Bali", detail: "Tanah Lot temple and Finns Beach Club sunset." },
      { title: "Ubud", detail: "Rice terraces, Bali swing and coffee plantation." },
      { title: "Kintamani", detail: "Volcano views and waterfall trek." },
      { title: "Leisure", detail: "Water sports at Nusa Dua or free day." },
      { title: "Departure", detail: "Transfer to airport for return flight." },
    ]),
  },
  {
    id: "t5",
    slug: "vietnam-group-tour",
    title: "Vietnam Group Tour",
    withFlights: true,
    location: "Vietnam",
    country: "Vietnam",
    duration: "8 Days | 7 Nights",
    nights: 7,
    price: 135000,
    status: "SOLD OUT",
    fill: 100,
    cover: SCENIC.halong,
    tagline: "Vietnam Discovery",
    short: "Da Nang, Hoi An, Phu Quoc, Hanoi & an overnight Ha Long Bay cruise.",
    description:
      "Explore the best of Vietnam in 8 Days / 7 Nights, covering Da Nang, Hoi An, Phu Quoc, Hanoi & Ha Long Bay. Enjoy the Golden Bridge, VinWonders, Vinpearl Safari, 4 Islands Tour, Hon Thom Cable Car, and an overnight Ha Long Bay cruise, with flights, hotels, visa, insurance, transfers, meals and sightseeing all included.",
    highlights: ["Golden Bridge, Ba Na Hills", "VinWonders & Safari, Phu Quoc", "Overnight Ha Long Bay cruise", "Hanoi Old Quarter"],
    inclusions: ["Return flights", "4★ hotels + cruise", "Daily breakfast", "Visa & insurance", "All transfers", "Sightseeing"],
    exclusions: ["Personal expenses", "2% TCS (as applicable)", "Optional tours"],
    gallery: [SCENIC.halong, GROUP_PHOTOS[0], GROUP_PHOTOS[1], GROUP_PHOTOS[2]],
    itinerary: baseItinerary([
      { title: "Arrive Da Nang", detail: "Transfer and evening at Dragon Bridge." },
      { title: "Ba Na Hills", detail: "Golden Bridge and cable car." },
      { title: "Hoi An", detail: "Ancient town and lantern cruise." },
      { title: "Fly to Phu Quoc", detail: "Beach resort check-in." },
      { title: "Phu Quoc", detail: "VinWonders and 4 Islands tour." },
      { title: "Fly to Hanoi", detail: "Old Quarter walking tour." },
      { title: "Ha Long Bay", detail: "Overnight luxury cruise." },
      { title: "Departure", detail: "Return to Hanoi and fly home." },
    ]),
  },
  {
    id: "t6",
    slug: "bali-indonesia-5d4n",
    title: "Bali (Indonesia) 5 Days and 4 Nights",
    withFlights: true,
    location: "Indonesia",
    country: "Bali (Indonesia)",
    duration: "4 Nights | 5 Days",
    nights: 4,
    price: 75000,
    status: "SOLD OUT",
    fill: 100,
    cover: SCENIC.bali2,
    tagline: "Bali Group Departure",
    short: "Return flights from Delhi, premium stay, ATV, Bali Swing, Kintamani & waterfalls.",
    description:
      "Experience the best of Bali with Flycher Travels' 4 Nights / 5 Days Bali Tour Package from Delhi. Enjoy return flights, a premium hotel stay with daily breakfast, private airport transfers, Finns Beach Club, ATV adventure, Bali Swing, Kintamani Volcano, Ubud Palace, waterfalls, coffee plantation, guided sightseeing, travel insurance, and more.",
    highlights: ["Finns Beach Club", "ATV adventure & Bali Swing", "Kintamani Volcano", "Ubud Palace & waterfalls"],
    inclusions: ["Return flights", "Premium hotel + breakfast", "Private transfers", "Guided sightseeing", "Travel insurance"],
    exclusions: ["Visa on arrival", "Personal expenses", "2% TCS (as applicable)", "Lunch & dinner"],
    gallery: [SCENIC.bali2, GROUP_PHOTOS[3], GROUP_PHOTOS[4], SCENIC.bali1],
    itinerary: baseItinerary([
      { title: "Arrive Bali", detail: "Pickup and check-in." },
      { title: "Beach Club", detail: "Finns Beach Club and sunset." },
      { title: "Ubud", detail: "Bali swing, palace and waterfalls." },
      { title: "Kintamani", detail: "Volcano and coffee plantation." },
      { title: "Departure", detail: "Transfer to airport." },
    ]),
  },
  {
    id: "t7",
    slug: "thailand-pattaya-bangkok",
    title: "Thailand Group Tour 5D/4N (Pattaya - Bangkok)",
    withFlights: true,
    location: "Thailand",
    country: "Thailand",
    duration: "4 Nights | 5 Days",
    nights: 4,
    price: 49000,
    status: "ALMOST SOLD OUT",
    fill: 88,
    cover: SCENIC.bangkok,
    tagline: "Land of Smiles",
    short: "Coral Island, Pattaya nightlife and Bangkok shopping with 4★ hotels.",
    description:
      "Escape to the Land of Smiles with our specially curated Thailand Group Departure. Experience the perfect blend of tropical beaches, vibrant nightlife, cultural attractions, and leisure time. From the crystal-clear waters of Coral Island to the lively streets of Pattaya and the shopping paradise of Bangkok, every moment is designed for a comfortable and memorable holiday. Enjoy guaranteed early check-in with breakfast on arrival.",
    highlights: ["Coral Island speedboat tour", "Pattaya beach & nightlife", "Bangkok city & temples", "Shopping at malls"],
    inclusions: ["Flights included", "4★ hotels", "Early check-in + breakfast", "All transfers", "Sightseeing", "Travel insurance"],
    exclusions: ["Visa fees", "Personal expenses", "2% TCS (as applicable)", "Optional shows"],
    gallery: [SCENIC.bangkok, GROUP_PHOTOS[5], GROUP_PHOTOS[6], GROUP_PHOTOS[7]],
    itinerary: baseItinerary([
      { title: "Arrive Bangkok → Pattaya", detail: "Transfer and evening leisure." },
      { title: "Coral Island", detail: "Speedboat tour and water sports." },
      { title: "Pattaya → Bangkok", detail: "City tour and shopping." },
      { title: "Bangkok", detail: "Temples and Chao Phraya river." },
      { title: "Departure", detail: "Transfer to airport." },
    ]),
  },
];

export const COUNTRIES = [
  { id: "sri-lanka", name: "Sri Lanka", packages: 1, from: 66500, image: SCENIC.sigiriya },
  { id: "singapore", name: "Singapore", packages: 1, from: 111000, image: SCENIC.singapore1 },
  { id: "bali", name: "Bali (Indonesia)", packages: 2, from: 75000, image: SCENIC.bali1 },
  { id: "multi", name: "Multi Country Tour", packages: 1, from: 125000, image: SCENIC.kl },
  { id: "vietnam", name: "Vietnam", packages: 1, from: 135000, image: SCENIC.halong },
  { id: "thailand", name: "Thailand", packages: 1, from: 49000, image: SCENIC.bangkok },
];

export const GALLERY = [
  { tag: "Dubai", image: GROUP_PHOTOS[0] },
  { tag: "Europe", image: GROUP_PHOTOS[1] },
  { tag: "Sri Lanka", image: GROUP_PHOTOS[2] },
  { tag: "Georgia", image: GROUP_PHOTOS[3] },
  { tag: "Malaysia", image: GROUP_PHOTOS[4] },
  { tag: "Vietnam", image: GROUP_PHOTOS[5] },
  { tag: "Thailand", image: GROUP_PHOTOS[6] },
  { tag: "Bali", image: GROUP_PHOTOS[7] },
  { tag: "Singapore", image: GROUP_PHOTOS[8] },
  { tag: "Manali", image: GROUP_PHOTOS[9] },
  { tag: "Bangkok", image: SCENIC.bangkok },
  { tag: "Ha Long", image: SCENIC.halong },
];

export const DOMESTIC = [
  { title: "Premium Mountain Tour", price: 12500, image: GROUP_PHOTOS[4], note: "Explore the best experiences across India" },
  { title: "Premium Andaman Experience", price: 45000, image: SCENIC.halong, note: "Explore the best experiences across India" },
];

export const TESTIMONIALS = [
  { name: "Aditi", trip: "Bali Escape", text: "Flawless planning and great hotel options. We just showed up and enjoyed without stressing over the details!" },
  { name: "Rahul", trip: "Thailand Loop", text: "Clear itinerary, complete price transparency, and zero hidden costs. Will definitely book my next trip here." },
  { name: "Sarah", trip: "Sri Lanka Trail", text: "Customer support was super responsive throughout our entire journey. Truly an effortless travel experience!" },
];

export const VIBES = [
  { emoji: "🏝️", label: "Beach", q: "beach" },
  { emoji: "⛰️", label: "Mountains", q: "mountain" },
  { emoji: "🏙️", label: "City Break", q: "city" },
  { emoji: "🏛️", label: "Heritage", q: "heritage" },
  { emoji: "🐅", label: "Wildlife", q: "wildlife" },
  { emoji: "🚗", label: "Road Trip", q: "road" },
];

export const formatINR = (n) =>
  "₹" + Number(n).toLocaleString("en-IN");
